module.exports = __webpack_public_path__ + "static/media/utility1.73bb7f41.svg";